import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as UsersActions } from "store/ducks/users";

import Filters from "pages/Configs/Users/components/Filters";

import { Access } from "common";
import {
  Page,
  Panel,
  Loading,
  Pagination,
  Breadcrumbs,
  Icon,
} from "components";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Configurações", to: "/configs" },
      { name: "Usuários", to: "" },
    ],
    filter: {
      name: "",
      ldap: "",
      group: null,
    },
  };

  componentDidMount() {
    const { location, getUsersRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getUsersRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getUsersRequest } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getUsersRequest(queryString.parse(location.search).page);
    }
  }

  handleChangeQuery = async (e) => {
    const { filter } = this.state;
    const { name, value } = e.target;

    this.setState({ filter: { ...filter, [name]: value } });
  };

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    this.setState({ filter: { ...filter, [name]: value } });
  };

  handleClean = async (e) => {
    e.preventDefault();

    this.setState({
      filter: {
        name: "",
        ldap: "",
        group: null,
      },
    });
  };

  handleFilter = (e) => {
    e.preventDefault();
    const { getUsersRequest } = this.props;

    getUsersRequest(1, this.state.filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { users } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Usuários</Page.Title>

        <Filters
          data={filter}
          onChange={this.handleChangeFilter}
          onClean={this.handleClean}
          onSubmit={this.handleFilter}
        />

        <Panel className="panel-list">
          {!users.data.length && users.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {users.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>email</th>
                    <th>grupos</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!users.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {users.data.map((user, index) => (
                    <tr key={user.id}>
                      <td>{user.attributes.name}</td>
                      <td>{user.attributes.email}</td>
                      <td>
                        {user.attributes.access_roles.groups
                          .map((group) => group.title)
                          .join(", ")}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions("edit-users") && (
                          <Link
                            to={`/configs/users/${user.id}/edit`}
                            className="button-icon"
                          >
                            <Icon name="pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                current={users.page}
                total={users.totals}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  users: state.users,
});

const mapActions = (dispatch) => bindActionCreators(UsersActions, dispatch);

export default connect(mapState, mapActions)(List);
